// ログイン.
export const LOGIN: string = 'LOGIN';

// メニュー
export const MENU: string = 'LOCOMO_DETAIL';

// 管理メニュー
export const SETTING: string = 'SETTING';
export const SETTING_CHANGE_PASSWORD: string = 'SETTING_CHANGE_PASSWORD';
export const SETTING_FORGOT_PASSWORD: string = 'SETTING_FORGOT_PASSWORD';
export const SETTING_FORGOT_PASSWORD_CODE: string = 'SETTING_FORGOT_PASSWORD_CODE';

// ロコモ予防トレーニング
export const USER_SELECT_LOCOMO = 'USER_SELECT_LOCOMO';
export const LOCOMO: string = 'LOCOMO';

// 日常生活動作トレーニング
export const USER_SELECT_ADL = 'USER_SELECT_ADL';
export const ADL: string = 'ADL';

// 個別機能訓練に関する記録
export const USER_SELECT_KIROKU = 'USER_SELECT_KIROKU';
export const KIROKU: string = 'KIROKU';

// モフトレ通信
export const USER_SELECT_PRESS = 'USER_SELECT_PRESS';
export const PRESS_SELECT_MONTH: string = 'PRESS_SELECT_MONTH';
export const PRESS: string = 'PRESS';

// モフトレチェック.
export const USER_SELECT_MOFF_CHECK = 'USER_SELECT_MOFF_CHECK';
export const MOFF_CHECK_SELECT_MONTH = 'MOFF_CHECK_SELECT_MONTH';
// 居宅訪問.
export const HOME_VISIT = 'HOME_VISIT';
export const HOME_VISIT_PRINT = 'HOME_VISIT_PRINT';

// 興味関心チェック.
export const USER_INTEREST_CHECK = 'USER_INTEREST_CHECK';
export const INTEREST_CHECK_PRINT = 'INTEREST_CHECK_PRINT';

// 機能訓練レポート.
export const USER_SELECT_LITERALLY_REPORT = 'USER_SELECT_LITERALLY_REPORT';
export const LITERALLY_REPORT_SELECT_MONTH = 'LITERALLY_REPORT_SELECT_MONTH';



// WEBPACK FOOTER //
// ./src/constants/Header.tsx